module.exports = __webpack_public_path__ + "img/deletion-warning.8b609d67.svg";